export default __webpack_public_path__ + "static/media/Phone.6b49f847.svg";